import { render } from "./InstrumentsControl.vue?vue&type=template&id=d5cb95fe&scoped=true"
import script from "./InstrumentsControl.vue?vue&type=script&lang=js"
export * from "./InstrumentsControl.vue?vue&type=script&lang=js"

import "./InstrumentsControl.vue?vue&type=style&index=0&id=d5cb95fe&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cb95fe"]])

export default __exports__